import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import ThemeIcon from './ThemeIcon';
import classes from './ThemeControl.styles.less';
export default function ThemeControl({ className }) {
    const [theme, setTheme] = useTheme();
    return (_jsx("div", { className: cx(classes.themeControl, classes[theme], className), children: _jsx("button", { className: classes.control, type: "button", onClick: () => setTheme(theme === 'light' ? 'dark' : 'light'), children: _jsxs("div", { className: classes.controlInner, children: [_jsx("div", { className: classes.label, children: "Toggle theme" }), _jsxs("div", { className: classes.currentTheme, children: [_jsx(ThemeIcon, { theme: theme, size: 15 }), _jsxs("div", { className: classes.name, children: [theme, " theme"] })] })] }) }) }));
}
